export default __webpack_public_path__ + "static/media/SeñorEquilibristaB2.0da35837.png";